/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Duration_LabelInputs */

const en_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const fr_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

const de_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const it_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

const ru_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность`)
};

const es_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const zh_cn2_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期间`)
};

const ja_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間隔`)
};

const hi_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_event_warning_duration_label = /** @type {(inputs: Event_Warning_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Event_Warning_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_duration_label = /** @type {((inputs?: Event_Warning_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_duration_label(inputs)
	if (locale === "de") return de_event_warning_duration_label(inputs)
	if (locale === "it") return it_event_warning_duration_label(inputs)
	if (locale === "ru") return ru_event_warning_duration_label(inputs)
	if (locale === "es") return es_event_warning_duration_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_duration_label(inputs)
	if (locale === "ja") return ja_event_warning_duration_label(inputs)
	if (locale === "hi") return hi_event_warning_duration_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_duration_label(inputs)
	return en_event_warning_duration_label(inputs)
});